import React, { useEffect } from "react";
import { useSelector } from "../../store";
import { Container } from "@mui/material";
import PageTitle from "../base/PageTitle";
import SecurityHub from "../views/SecurityHub";
import { useNavigate } from "react-router-dom";
import checkRole, { UserRoles } from "../../helpers/checkUserRoles";

interface Props {}

const SecurityHubPage: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  const { globalLoadingState } = useSelector((store) => store.shared);

  const { dbUser } = useSelector((store) => store.auth);

  useEffect(() => {
    if (!!dbUser) {
      const auth = checkRole(dbUser, UserRoles.AnyAdmin);
      if (!auth) {
        navigate("/apps");
      }
    }
  }, [navigate, dbUser]);

  return !globalLoadingState.isLoading ? (
    <Container>
      <PageTitle title="Security Hub Management" />
      <SecurityHub />
    </Container>
  ) : (
    <></>
  );
};

export default SecurityHubPage;
